module.exports = __webpack_public_path__ + "media/images/CrossElasticityRed-14f29f72b9b7f2e2973906a8f24de282.png";